export class BobFreshFoodLegInfo {
    PaxCount?: number;
    UpdatedOn?: string;
}